import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M4,2.50034732 C4,2.22401312 4.23193359,2 4.5,2 C4.77614237,2 5,2.22900057 5,2.50034732 L5,13.4996527 C5,13.7759869 4.76806641,14 4.5,14 C4.22385763,14 4,13.7709994 4,13.4996527 L4,2.50034732 Z M11,2.50034732 C11,2.22401312 11.2319336,2 11.5,2 C11.7761424,2 12,2.22900057 12,2.50034732 L12,13.4996527 C12,13.7759869 11.7680664,14 11.5,14 C11.2238576,14 11,13.7709994 11,13.4996527 L11,2.50034732 Z"/>
  </svg>
);
